import { render, staticRenderFns } from "./SimpleListComponent.vue?vue&type=template&id=10787765&"
import script from "./SimpleListComponent.vue?vue&type=script&lang=js&"
export * from "./SimpleListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports